import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { InstantSearchBoxComponent } from '@cumlaude/shared-components-inputs';
import { RestService } from '@cumlaude/shared-services';
import { getRolShort, RCumLaudeAccount, RRol } from '@cumlaude/service-contract';

@Component({
	selector: 'app-gebruikers-page',
	templateUrl: './gebruikers-page.component.html',
	styleUrls: ['./gebruikers-page.component.scss'],
	imports: [AsyncPipe, InstantSearchBoxComponent],
})
export class GebruikersPageComponent {
	private readonly restService = inject(RestService);
	private readonly router = inject(Router);

	searchInput$ = new BehaviorSubject<string>('');
	accounts$: Observable<RCumLaudeAccount[]> = this.searchInput$.pipe(
		switchMap((q) => {
			const query = q.trim();
			return query === '' ? of([]) : this.restService.getAccountsFromFilter({ quicksearch: query });
		})
	);

	gotoInstelling(account: RCumLaudeAccount) {
		if (account.instelling.id) this.router.navigate(['instelling', account.instelling.id], { queryParams: { account: account.id } });
	}

	rollenShort(rollen: RRol[]): string {
		return rollen.map((rol) => getRolShort(rol)).join();
	}
}
